import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

export const useConOrdenPago = () => {
    const { asistenciasMes } = useSelector(state => state.reportesReducer)
    const [asistencias, setAsistencias] = useState(0)
    const [costo, setCosto] = useState(0)

    useEffect(() => {
        const listaNueva = asistenciasMes.filter(a => a.fechaCreacionOP)
        let a = 0;
        let c = 0;
        listaNueva.map((asis) => {
            a++;
            c = c + Number(asis.costo)
        })

        setAsistencias(a)
        setCosto(c)

    }, [asistenciasMes])

    return { asistencias, costo }
}
